import React from 'react';

import PropTypes from 'prop-types';

import {
    PageSection,
    SectionTitle,
    MarkdownContent,
} from 'wanderu-components';

import {
    AWARDS_IMAGE,
} from '../../constants';

import styles from './AwardsSection.scss';

const propTypes = {
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

function AwardsSection(props) {
    const {
        description,
        title,
    } = props;

    return (
        <PageSection
            aria-labelledby="awards-section"
            className={styles.awardsSection}
            layoutClassName={styles.awardsSectionLayout}
        >
            <SectionTitle id="awards-section">
                {title}
            </SectionTitle>
            <img
                alt=""
                src={AWARDS_IMAGE}
            />
            <MarkdownContent className={styles.awardsSectionDescription}>
                {description}
            </MarkdownContent>
        </PageSection>
    );
}

AwardsSection.propTypes = propTypes;

export default AwardsSection;
